/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Refs_P2Inputs */

const en_wc_tut_refs_p2 = /** @type {(inputs: Wc_Tut_Refs_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert footnotes and endnotes, add sources and citations in APA, MLA, Chicago or IEEE style, then insert a bibliography, captions, a table of figures or an index.`)
};

/**
* | output |
* | --- |
* | "Insert footnotes and endnotes, add sources and citations in APA, MLA, Chicago or IEEE style, then insert a bibliography, captions, a table of figures or an i..." |
*
* @param {Wc_Tut_Refs_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_refs_p2 = /** @type {((inputs?: Wc_Tut_Refs_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Refs_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_refs_p2(inputs)
});
export { wc_tut_refs_p2 as "wc.tut.refs.p2" }